<template>
  <div 
    id="board-wrap"
    @mousedown="start_down($event)"
    @mousemove="start_move($event)"
    @mouseup="start_end($event)"
    @mouseleave="canvasLeave($event)"
    @touchstart="start_down($event)"
    @touchmove="start_move($event)"
    @touchend="start_end($event)"
    @touchcancel="canvasLeave($event)"
    oncontextmenu="return false;"
  >
    <div class="recall-wrap">
      <canvas ref="recall-canvas"></canvas>
    </div>
    <div 
      id="canvasPart" 
      ref="canvasBox"
      :style="{ background: canvasSet.back }" 
    >
      <canvas
        id="canvas"
        ref="canvas"
      >抱歉，您的浏览器不支持canvas元素</canvas>
      <div 
        v-show="showEraser" 
        class="eraser-wrap"
        :style="{
          transform: `translate(${eraserPosition.x}px, ${eraserPosition.y}px)`,
        }"
      >
        <img 
          class="eraser" 
          :style="{
            width: `${eraserSize.width}px`,
            height: `${eraserSize.height}px`,
          }"
          src="~@/assets/images/eraser_ico.svg" alt=""
        >
      </div>
    </div>
    <div id="shape-container" 
      class="shape" 
      :class="{
        'show': showShapeCanvas,
      }"
    >
      <canvas ref="shape-canvas">抱歉，您的浏览器不支持canvas元素</canvas>
    </div>
    <div 
      v-show="showControlBar" 
      id="control-bar" 
      class="control-bar"
      :style="{
        left: `${controlBarPos.left}px`,
        top: `${controlBarPos.top}px`,
      }"
    >
      <div class="shape-item">
        <img src="~@/assets/images/shape_border.svg" alt="">
        <div class="text">边框</div>
      </div>
      <div class="shape-color-list">
        <div 
          v-for="(color, index) in borderColor" 
          :key="color" 
          @click="selectBorderColor(index)"
          class="color-item"
          :class="{
            selected: currentBorderColorIndex === index,
          }"
          :style="{
            backgroundColor: color,
          }"
        >
        </div>
      </div>
      <div class="delete-shape" @click="deleteShape">
        <img src="~@/assets/images/delete_shape.svg" class="img-icon" alt="">
        <div class="text">删除</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { fabric } from 'fabric';

  export default {
    props: {
      // canvas 宽高
      domWidHei: {
        type: Object
      },
      // 画笔设置
      canvasSet: {
        type: Object
      },
      // 批改底图
      imgSrc: {
        type: String
      },
      // 旋转角度
      rotateDeg: {},
      isClickScore: {
        type: Boolean
      },
    },
    data() {
      const eraserSize = {
        width: 60,
        height: 80,
      };

      if (this.isPc()) {
        eraserSize.width *= 2;
        eraserSize.height *= 2;
      }

      return{
        window_width: this.domWidHei.width, // 窗口宽
        window_height: this.domWidHei.height, // 窗口高
        canvas_set: _.cloneDeep(this.canvasSet),
        canvas_context: null,
        is_write: false, // 是否手写
        img_src: this.imgSrc,
        pId: 'p1',
        lines: {},
        isAddShape: false,
        showShapeCanvas: false,
        recallList: [],
        recallBackList: [],
        recallCanvasCtx: null,
        isPreviousAddShape: false,
        eraserSize,
        eraserPoints: [],
        showEraser: false,
        eraserPosition: {
          x: 0,
          y: 0,
        },
        isDraw: false,
        showControlBar: false,
        controlBarPos: {
          left: 0,
          top: 0,
        },
        controlRect: null,
        controlRectStrokeWidth: 2,
        currentBorderColorIndex: 0,
        borderColor: [
          '#FFA700',
          '#13CE66',
          '#FF5A48',
          '#037BFE',
        ],
      };
    },
    methods:{
      // 初始化canvas
      init_canvas () {
        this.recallList = [];
        this.recallBackList = [];
        this.isDraw = false;
        this.$refs.canvas.width = this.window_width;
        this.$refs.canvas.height = this.window_height;
        this.canvas_context = this.$refs.canvas.getContext('2d');
        this.canvas_context.clearRect(0, 0, this.window_width * 4, this.window_height * 4);
        this.canvas_context.lineCap = 'round';
        this.canvas_context.lineJoin = 'round';

        this.$refs['recall-canvas'].width = this.window_width;
        this.$refs['recall-canvas'].height = this.window_height;
        this.recallCanvasCtx = this.$refs['recall-canvas'].getContext('2d');
        this.recallCanvasCtx.lineCap = 'round';
        this.recallCanvasCtx.lineJoin = 'round';

        //设置线条模糊程度
        // this.canvas_context.shadowBlur = 1;
        this.initShapeCanvas();
      },
      setCanvasBg() {
        if (!this.img_src) {
          return;
        }

        const img = new Image();
        img.setAttribute('crossOrigin', 'Anonymous');
        img.src = this.img_src;
        img.onload = () => {
          this.clear_canvas();
          this.canvas_context.drawImage(img, 0, 0, this.window_width, this.window_height);
          this.isDraw = true;
        };
      },
      createControls(ctx) {
        const controlsUtils = fabric.controlsUtils;
        const scalingEqually = controlsUtils.scalingEqually;
        const controls = {};
        const rect = ctx.getBoundingRect();
        const tlCursorStyleHandler = () => {
          return 'nw-resize';
        };
        const trCursorStyleHandler = () => {
          return 'ne-resize';
        };
        const blCursorStyleHandler = () => {
          return 'sw-resize';
        };
        const brCursorStyleHandler = () => {
          return 'se-resize';
        };

        let angle = ctx.angle % 360;

        if (angle < 0) {
          angle += 360;
        }

        const p1 = new fabric.Point(rect.left, rect.top);
        let localPoint;
        
        if (angle >= 0 && angle < 90) {
          localPoint = ctx.toLocalPoint(p1, 'left', 'top');
          controls.tl = new fabric.Control({
            x: -0.5,
            y: -0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: tlCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left + rect.width, rect.top);
          localPoint = ctx.toLocalPoint(p1, 'right', 'top');
          controls.tr = new fabric.Control({
            x: 0.5,
            y: -0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: trCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left + rect.width, rect.top + rect.height);
          localPoint = ctx.toLocalPoint(p1, 'right', 'bottom');
          controls.br = new fabric.Control({
            x: 0.5,
            y: 0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: brCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left, rect.top + rect.height);
          localPoint = ctx.toLocalPoint(p1, 'left', 'bottom');
          controls.bl = new fabric.Control({
            x: -0.5,
            y: 0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: blCursorStyleHandler,
            actionHandler: scalingEqually,
          });
        } else if (angle >= 90 && angle < 180) {
          localPoint = ctx.toLocalPoint(p1, 'left', 'bottom');
          controls.bl = new fabric.Control({
            x: -0.5,
            y: 0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: tlCursorStyleHandler,
            actionHandler: scalingEqually,
          });
          
          p1.setXY(rect.left + rect.width, rect.top);
          localPoint = ctx.toLocalPoint(p1, 'left', 'top');
          controls.tl = new fabric.Control({
            x: -0.5,
            y: -0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: trCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left + rect.width, rect.top + rect.height);
          localPoint = ctx.toLocalPoint(p1, 'right', 'top');
          controls.tr = new fabric.Control({
            x: 0.5,
            y: -0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: brCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left, rect.top + rect.height);
          localPoint = ctx.toLocalPoint(p1, 'right', 'bottom');
          controls.br = new fabric.Control({
            x: 0.5,
            y: 0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: blCursorStyleHandler,
            actionHandler: scalingEqually,
          });
        } else if (angle >= 180 && angle < 270) {
          localPoint = ctx.toLocalPoint(p1, 'right', 'bottom');
          controls.br = new fabric.Control({
            x: 0.5,
            y: 0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: tlCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left + rect.width, rect.top);
          localPoint = ctx.toLocalPoint(p1, 'left', 'bottom');
          controls.bl = new fabric.Control({
            x: -0.5,
            y: 0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: trCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left + rect.width, rect.top + rect.height);
          localPoint = ctx.toLocalPoint(p1, 'left', 'top');
          controls.tl = new fabric.Control({
            x: -0.5,
            y: -0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: brCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left, rect.top + rect.height);
          localPoint = ctx.toLocalPoint(p1, 'right', 'top');
          controls.tr = new fabric.Control({
            x: 0.5,
            y: -0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: blCursorStyleHandler,
            actionHandler: scalingEqually,
          });
        } else if (angle >= 270 && angle < 360) {
          localPoint = ctx.toLocalPoint(p1, 'right', 'top');
          controls.tr = new fabric.Control({
            x: 0.5,
            y: -0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: tlCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left + rect.width, rect.top);
          localPoint = ctx.toLocalPoint(p1, 'right', 'bottom');
          controls.br = new fabric.Control({
            x: 0.5,
            y: 0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: trCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left + rect.width, rect.top + rect.height);
          localPoint = ctx.toLocalPoint(p1, 'left', 'bottom');
          controls.bl = new fabric.Control({
            x: -0.5,
            y: 0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: brCursorStyleHandler,
            actionHandler: scalingEqually,
          });

          p1.setXY(rect.left, rect.top + rect.height);
          localPoint = ctx.toLocalPoint(p1, 'left', 'top');
          controls.tl = new fabric.Control({
            x: -0.5,
            y: -0.5,
            offsetX: localPoint.x,
            offsetY: localPoint.y,
            cursorStyleHandler: blCursorStyleHandler,
            actionHandler: scalingEqually,
          });
        }

        p1.setXY(rect.left + rect.width / 2, rect.top - 60);
        localPoint = ctx.toLocalPoint(p1, 'center', 'top');
        controls.mtr = new fabric.Control({
          x: 0,
          y: -0.5,
          actionHandler: controlsUtils.rotationWithSnapping,
          cursorStyleHandler: controlsUtils.rotationStyleHandler,
          offsetX: localPoint.x,
          offsetY: localPoint.y,
          // offsetY: -40,
          withConnection: false,
          actionName: 'rotate',
        });

        return controls;
      },
      hookFabric() {
        const createControls = this.createControls;

        fabric.controlsUtils.renderCircleControl = function renderCircleControl (ctx, left, top, styleOverride, fabricObject) {
          styleOverride = styleOverride || {};
          var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize,
              ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize,
              transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ?
                styleOverride.transparentCorners : this.transparentCorners,
              methodName = transparentCorners ? 'stroke' : 'fill',
              stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor),
              myLeft = left,
              myTop = top, size;
          ctx.save();
          ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
          ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor;
          // as soon as fabric react v5, remove ie11, use proper ellipse code.
          if (xSize > ySize) {
            size = xSize;
            ctx.scale(1.0, ySize / xSize);
            myTop = top * xSize / ySize;
          }
          else if (ySize > xSize) {
            size = ySize;
            ctx.scale(xSize / ySize, 1.0);
            myLeft = left * ySize / xSize;
          }
          else {
            size = xSize;
          }
          // this is still wrong
          const lineWidth = styleOverride.lineWidth || 1;
          ctx.lineWidth = lineWidth;
          ctx.beginPath();
          ctx.arc(myLeft, myTop, size / 2, 0, 2 * Math.PI, false);
          ctx[methodName]();
          if (stroke) {
            ctx.stroke();
          }
          ctx.restore();
        };

        fabric.Object.prototype.drawControls = function (ctx, styleOverride) {
          styleOverride = styleOverride || {};
          styleOverride.lineWidth = 2;
          ctx.save();
          ctx.setTransform(this.canvas.getRetinaScaling(), 0, 0, this.canvas.getRetinaScaling(), 0, 0);
          ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;

          if (!this.transparentCorners) {
            ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
          }
          this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray, null);

          // this.controls = createControls(this);
          this.setCoords();

          this.forEachControl(function(control, key, fabricObject) {
            if (control.getVisibility(fabricObject, key)) {
              const { x, y } = fabricObject.oCoords[key];

              styleOverride.cornerColor = key === 'mtr' ? '#44D7B6' : '#fff';
              control.render(ctx, x, y, styleOverride, fabricObject);
            }
          });
          ctx.restore();
          return this;
        };
      },
      initShapeCanvas() {
        this.hookFabric();

        fabric.Object.prototype.transparentCorners = false;
        fabric.Object.prototype.noScaleCache = false;
        fabric.Object.prototype.borderColor = '#44D7B6';
        fabric.Object.prototype.cornerStrokeColor = '#44D7B6';
        fabric.Object.prototype.cornerSize = 12;
        fabric.Object.prototype.cornerStyle = 'circle';

        this.shapeCanvasCtx = new fabric.Canvas(this.$refs['shape-canvas'], {
          isDrawingMode: false,
          enableRetinaScaling: false,
          width: this.window_width,
          height: this.window_height,
        });

        this.shapeCanvasCtx.on({
          'mouse:down:before': (e) => {
            if (this.isAddShape) {
              this.isAddShape = !!e.target;
            }

            if (!this.isAddShape) {
              this.shapeCanvasCtx.discardActiveObject().renderAll();
              this.canvas_context.drawImage(
                this.shapeCanvasCtx.getContext().canvas, 
                0, 0,
                this.window_width, this.window_height
              );
              this.showShapeCanvas = false;
              this.showControlBar = false;
              this.shapeCanvasCtx.clear();
              this.is_write = true;
              this.isPreviousAddShape = true;

              this.pushOp({
                type: 'snapshot',
                data: this.canvas_context.getImageData(0, 0, this.window_width, this.window_height),
              });

              this.canvas_context.strokeStyle = this.canvas_set.line_color;
              this.canvas_context.lineWidth = this.canvas_set.line_width;
            }
          },
          'object:moving': (e) => {
            if (this.isAddShape) {
              this.hideControls(e.target);
            }
          },
          'object:moved': (e) => {
            if (this.isAddShape) {
              this.updateControlsState(e.target);
            }
          },
          'object:rotating': (e) => {
            if (this.isAddShape) {
              this.hideControls(e.target);
            }
          },
          'object:rotated': (e) => {
            if (this.isAddShape) {
              this.updateControlsState(e.target);
            }
          },
          'object:scaling': (e) => {
            if (this.isAddShape) {
              this.hideControls(e.target);
            }
          },
          'object:scaled': (e) => {
            if (this.isAddShape) {
              this.updateControlsState(e.target);
            }
          },
        });
      },
      hideControls(object) {
        object.hasControls = false;
        this.showControlBar = false;
      },
      updateControlsState(object) {
        this.pushOp({
          type: 'draw',
          actionType: 'shape',
          data: object.toJSON(),
          extra: {
            borderColorIndex: this.currentBorderColorIndex,
          },
        });

        object.hasControls = true;
        this.showControlBar = true;

        const bound = object.getBoundingRect();
        this.updateControlBarPos(bound, object.oCoords);
      },
      updateControlBarPos(shapeBound, oCoords) {
        const bound = shapeBound;
        const toolbarWidth = 330;
        const offsetTop = 30;
        let bottom = bound.top + bound.height;

        if (oCoords.mtr.y > bottom) {
          bottom = oCoords.mtr.y;
        }

        this.controlBarPos.left = bound.left + (bound.width - toolbarWidth) / 2;
        this.controlBarPos.top = bottom + offsetTop;
      },
      start_down (event) {
        if (this.isAddShape || this.canvas_set.pen_type == 'move') return;

        event.preventDefault();
        this.is_write = true;

        // 设置线条颜色
        this.canvas_context.strokeStyle = this.canvas_set.line_color;
        // 设置线条宽度
        this.canvas_context.lineWidth = this.canvas_set.line_width;
        // 设置模糊颜色
        // this.canvas_context.shadowColor = this.canvas_set.line_color;

        // this.showEraser = this.canvas_set.pen_type == 'eraser';

        if (this.canvas_set.pen_type == 'eraser') {
          
          // const firstPointPos = this.getFirstPointPos(event);
          // this.updateEraserPos(firstPointPos);
          // this.showEraser = true;
          return;
        }

        if (this.canvas_set.pen_type == 'pen') {
          // 判断是否是移动端
          if (event.touches) {
            Array.from(event.touches).forEach((touch) => {
              this.lines[touch.identifier] = {
                points: [
                  {
                    x: touch.pageX,
                    y: touch.pageY,
                  },
                ],
              };
            });
          } else {
            this.lines[this.pId] = {
              points: [
                {
                  x: Math.round(event.pageX),
                  y: Math.round(event.pageY),
                },
              ],
            };
          }
          return;
        }
      },
      getFirstPointPos(event) {
        let x;
        let y;

        if (event.touches) {
          const touch = event.touches[0];
          x = touch.pageX;
          y = touch.pageY;
        } else {
          x = event.pageX;
          y = event.pageY;
        }

        return {
          x,
          y,
        };
      },
      updateEraserPos({ x, y, }) {
        this.eraserPosition.x = x - this.eraserSize.width / 2;
        this.eraserPosition.y = y - this.eraserSize.height / 2;
      },
      start_move(event) {
        event.preventDefault();
        if (this.isAddShape) return;

        const firstPointPos = this.getFirstPointPos(event);

        if (this.canvas_set.pen_type == 'eraser') {
          this.updateEraserPos(firstPointPos);
          this.showEraser = true;
        }
        
        if (this.is_write) {
          if (this.canvas_set.pen_type == 'eraser') {
            const pos = {
              x: firstPointPos.x,
              y: firstPointPos.y,
            };
            this.clearRect(this.canvas_context, pos);
            this.eraserPoints.push(pos);

            return;
          }

          if (event.changedTouches) {
            for (let i = 0; i < event.changedTouches.length; i++) {
              const touch = event.changedTouches[i];
              const id = touch.identifier;

              if (!this.lines[id]) {
                this.lines[id] = {
                  points: [],
                };
              }

              const line = this.lines[id];

              line.points.push({
                x: touch.pageX,
                y: touch.pageY,
              });
    
              if (line.points.length > 1) {
                this.drawLine(this.canvas_context, line);
              }
            }
          } else {
            if (!this.lines[this.pId]) {
              this.lines[this.pId] = {
                points: [],
              };
            }

            const line = this.lines[this.pId];

            line.points.push({
              x: Math.round(event.pageX),
              y: Math.round(event.pageY),
            });

            if (line.points.length > 1) {
              this.drawLine(this.canvas_context, line);
            }
          }
        }
      },
      clearRect(ctx, { x , y }) {
        ctx.clearRect(
          x - this.eraserSize.width / 2,
          y - this.eraserSize.height / 2,
          this.eraserSize.width, 
          this.eraserSize.height,
        );
      },
      drawLine(ctx, line) {
        ctx.save();
        ctx.beginPath();
        if (line.oldEnd) {
          ctx.moveTo(line.oldEnd.x, line.oldEnd.y);
        }

        const { length } = line.points;
        line.oldEnd = this.drawSegment(ctx, line.points[length - 2], line.points[length - 1]);
        ctx.stroke();
        ctx.restore();
      },
      drawSegment(ctx, p1, p2) {
        const midX = (p1.x + p2.x) / 2;
        const midY = (p1.y + p2.y) / 2;

        const midPoint = {
          x: midX,
          y: midY,
        };
        ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
        return midPoint;
      },
      start_end(event) {
        if (this.isAddShape || !this.is_write) return;

        if (this.canvas_set.pen_type == 'pen') {
          if (event.changedTouches) {
            for (let i = 0; i < event.changedTouches.length; i++) {
              const touch = event.changedTouches[i];
              const id = touch.identifier;
              const line = this.lines[id];

              if (line) {
                const point = {
                  x: touch.pageX,
                  y: touch.pageY,
                };
    
                line.points.push(point);
    
                if (line.points.length > 1) {
                  this.drawLine(this.canvas_context, line);
                }
    
                this.pushAction(line);
                this.lines[id] = null;
              }
            }
          } else {
            const line = this.lines[this.pId];
            if (this.isPreviousAddShape && line.points.length <= 1) {
              // noop
            } else {
              if (line) {
                const point = {
                  x: Math.round(event.pageX),
                  y: Math.round(event.pageY),
                };
    
                line.points.push(point);
    
                if (line.points.length > 1) {
                  this.drawLine(this.canvas_context, line);
                }
    
                this.pushAction(line); 
              }
            }

            this.isPreviousAddShape = false;
          }
        }

        if (event.touches && event.touches.length === 0 && this.canvas_set.pen_type == 'pen') {
          Object.values(this.lines).filter((line) => !!line).forEach((line) => {
            if (line.points && line.points.length > 1) {
              this.pushAction(line); 
            }
          });
        }

        if (!event.touches || event.touches.length === 0) {
          if (this.canvas_set.pen_type == 'eraser') {
            this.pushOp({
              type: 'draw',
              actionType: 'eraser',
              data: this.eraserPoints,
            });
          }
          
          this.is_write = false;
          this.lines = {};
          this.eraserPoints = [];

          if (event.touches) {
            this.showEraser = false;
          }
        }
      },
      pushAction(line) {
        if (this.recallList.length % 10 === 0) {
          const imgData = this.canvas_context.getImageData(0, 0, this.window_width, this.window_height);
          this.pushOp({
            type: 'snapshot',
            data: imgData,
          });
        } else {
          this.pushOp({
            type: 'draw',
            actionType: 'line',
            data: {
              color: this.canvas_set.line_color,
              width: this.canvas_set.line_width,
              line: {
                points: _.cloneDeep(line.points),
              },
            },
          });
        }
      },
      getImgUrl() {
        // this.recallCanvasCtx.save();
        // this.recallCanvasCtx.fillStyle = this.canvasSet.back;
        // this.recallCanvasCtx.fillRect(0, 0, this.window_width, this.window_height);
        // this.recallCanvasCtx.restore();

        if (this.isAddShape) {
          this.shapeCanvasCtx.discardActiveObject().renderAll();
          this.canvas_context.drawImage(
            this.shapeCanvasCtx.getContext().canvas, 
            0, 0,
            this.window_width, this.window_height
          );
          this.showShapeCanvas = false;
          this.showControlBar = false;
          this.shapeCanvasCtx.clear();
          this.isAddShape = false;
        }

        this.recallCanvasCtx.drawImage(
          this.canvas_context.canvas, 
          0, 0,
          this.window_width, this.window_height
        );

        const img = this.recallCanvasCtx.canvas.toDataURL('image/png');
        this.recallCanvasCtx.clearRect(0, 0, this.window_width, this.window_height);
        return img;
      },
      pushOp(op) {
        this.recallList.push(op);
        this.recallBackList = [];
        this.isDraw = true;
      },
      //鼠标移出canvas
      canvasLeave () {
        this.window_width = this.domWidHei.width;
        this.window_height = this.domWidHei.height;
        this.is_write = false;
        this.showEraser = false;
      },
      //清空画板
      clear_canvas () {
        if (this.isAddShape) {
          this.isAddShape = false;
          this.showShapeCanvas = false;
          this.showControlBar = false;
          this.shapeCanvasCtx.clear();
        }

        this.canvas_context.clearRect(
          0,
          0,
          this.window_width,
          this.window_height,
        );
        this.recallList = [];
        this.recallBackList = [];
        this.isDraw = false;
      },
      //撤销批改
      canvas_cancel() {
        this.recall();
      },
      drawContinueLine(ctx, line) {
        const lines = _.cloneDeep(line);
        const { length } = lines.points;

        ctx.save();
        ctx.beginPath();

        if (length > 1) {
          for (let i = 0; i <= length - 2; i++) {
            if (lines.oldEnd) {
              ctx.moveTo(lines.oldEnd.x, lines.oldEnd.y);
            }

            lines.oldEnd = this.drawSegment(ctx, lines.points[i], lines.points[i + 1]);
          }
        }

        ctx.stroke();
        ctx.restore();
      },
      enlivenObject(obj) {
        return new Promise((resovle) => {
          fabric.util.enlivenObjects([ obj ], (objects) => {
            objects.forEach((o) => {
              o.set('strokeUniform', true);

              this.shapeCanvasCtx.add(o);
              this.shapeCanvasCtx.setActiveObject(o);
              this.isAddShape = true;
              this.showShapeCanvas = true;
              resovle();
            });
          });
        });
      },
      async getSnapshotFromDraw() {
        const { length } = this.recallList;

        let bgData;
        for (let i = length - 2; i >= 0; i--) {
          const { type, data } = this.recallList[i];
          if (type === 'snapshot') {
            bgData = {
              index: i,
              data,
            };
            break;
          }
        }

        this.shapeCanvasCtx.clear();

        if (bgData) {
          this.recallCanvasCtx.putImageData(
            bgData.data, 
            0, 0, 0, 0,
            this.window_width,
            this.window_height
          );
        }

        const startPoint = bgData ? bgData.index + 1 : 0;
        for (let i = startPoint; i < length; i++) {
          const { actionType, data, } = this.recallList[i];

          switch (actionType) {
            case 'line':
              this.recallCanvasCtx.save();
              this.recallCanvasCtx.strokeStyle = data.color;
              this.recallCanvasCtx.lineWidth = data.width;
              this.drawContinueLine(this.recallCanvasCtx, data.line);
              this.recallCanvasCtx.restore();
              break;
    
            case 'shape':
              i = length - 1;
              await this.enlivenObject(this.recallList[i].data);
              this.currentBorderColorIndex = this.recallList[i].extra.borderColorIndex;
              break;
    
            case 'eraser':
              data.forEach((point) => {
                this.clearRect(this.recallCanvasCtx, point);
              });
              break;
          }
        }

        this.canvas_context.drawImage(
          this.recallCanvasCtx.canvas, 
          0, 0,
          this.window_width, this.window_height
        );
        this.recallCanvasCtx.clearRect(0, 0, this.window_width, this.window_height);

        const lastActionType = this.recallList[length - 1].actionType;

        if (lastActionType === 'shape') {
          this.showControlBar = true;

          const object = this.shapeCanvasCtx.getActiveObject(); 
          const bound = object.getBoundingRect();
          const oCoords = object.oCoords;
          this.updateControlBarPos(bound, oCoords);
        } else {
          this.showControlBar = false;
        }
      },
      clearShapeCanvas() {
        this.isAddShape = false;
        this.showShapeCanvas = false;
        this.shapeCanvasCtx.clear();
      },
      recall() {
        if (this.recallList.length <= 0) {
          return;
        };

        this.recallBackList.push(this.recallList.pop());
        this.canvas_context.clearRect(0, 0, this.window_width, this.window_height);
        this.clearShapeCanvas();

        const { length } = this.recallList;
        if (length > 0) {
          const op = this.recallList[length - 1];

          switch (op.type) {
            case 'draw':
              this.getSnapshotFromDraw();
              break;
            
            case 'snapshot':
              this.isAddShape = false;
              this.showShapeCanvas = false;
              this.canvas_context.putImageData(
                op.data, 
                0, 0, 0, 0,
                this.window_width,
                this.window_height
              );
              this.showControlBar = false;
              break;
          }
        } else {
          this.showControlBar = false;
        }
      },
      //恢复撤销
      re_canvas_cancel() {
        this.recallBack();
      },
      recallBack() {
        if (this.recallBackList.length <= 0) return;

        this.canvas_context.clearRect(0, 0, this.window_width, this.window_height);
        const op = this.recallBackList.pop();
        this.recallList.push(op);
        this.isDraw = true;

        switch (op.type) {
          case 'draw':
            this.getSnapshotFromDraw();
            break;
          
          case 'snapshot':
            this.isAddShape = false;
            this.showShapeCanvas = false;
            this.canvas_context.putImageData(
              op.data, 
              0, 0, 0, 0,
              this.window_width,
              this.window_height
            );
            this.showControlBar = false;
            break;
        }
      },
      getShapePosTopDiffWithToolbar(oCoords) {
        const toolbarTop = window.innerHeight - 238;
        const shapeTop = oCoords.bl.y + 90;

        return toolbarTop - shapeTop;
      },
      // 添加图形
      addShape(name) {
        if (this.isAddShape) {
          this.shapeCanvasCtx.discardActiveObject().renderAll();
          this.canvas_context.drawImage(
            this.shapeCanvasCtx.getContext().canvas, 
            0, 0,
            this.window_width, this.window_height
          );
          this.shapeCanvasCtx.clear();

          this.pushOp({
            type: 'snapshot',
            data: this.canvas_context.getImageData(0, 0, this.window_width, this.window_height),
          });
        }

        this.currentBorderColorIndex = 0;
        const shapeUrl = require(`@/assets/images/${name}`);
        fabric.loadSVGFromURL(shapeUrl, (objects, options) => {
          objects.forEach((o) => {
            o.set('strokeUniform', true);
          });

          const shape = fabric.util.groupSVGElements(objects, options);
          this.setShapeStrokeColor(shape, this.borderColor[this.currentBorderColorIndex]);

          this.shapeCanvasCtx.add(shape);
          shape.center().setCoords();

          if (window.innerWidth <= 810) {
            const oCoords = shape.oCoords;
            const diff = this.getShapePosTopDiffWithToolbar(oCoords);

            if (diff < 0) {
              const top = oCoords.tl.y + diff - 30;
              shape.set('top', top).setCoords();
            }
          }

          this.shapeCanvasCtx.setActiveObject(shape);
          this.isAddShape = true;
          this.showShapeCanvas = true;

          this.pushOp({
            type: 'draw',
            actionType: 'shape',
            data: shape.toJSON(),
            extra: {
              borderColorIndex: this.currentBorderColorIndex,
            },
          });

          const bound = shape.getBoundingRect();
          const oCoords = shape.oCoords;
          this.showControlBar = true;
          this.updateControlBarPos(bound, oCoords);
        });
      },
      deleteShape() {
        const object = this.shapeCanvasCtx.getActiveObject();
        this.pushOp({
          type: 'draw',
          actionType: 'shape',
          data: object.toJSON(),
          extra: {
            borderColorIndex: this.currentBorderColorIndex,
          },
        });

        this.shapeCanvasCtx.remove(object);
        this.showControlBar = false;
      },
      selectBorderColor(index) {
        this.currentBorderColorIndex = index;

        const color = this.borderColor[index];
        const object = this.shapeCanvasCtx.getActiveObject();
        this.setShapeStrokeColor(object, color);

        this.pushOp({
          type: 'draw',
          actionType: 'shape',
          data: object.toJSON(),
          extra: {
            borderColorIndex: this.currentBorderColorIndex,
          },
        });

        this.shapeCanvasCtx.renderAll();
      },
      setShapeStrokeColor(shape, color) {
        if (shape._objects) {
          shape._objects.forEach((object) => {
            object.set('stroke', color);
          });
        } else {
          shape.set('stroke', color);
        }
      },
    },
    mounted(){
      this.init_canvas();
    },
    watch:{
      canvasSet: {
        handler(newVal) {
            this.canvas_set = _.cloneDeep(newVal);

            if (this.canvas_set.pen_type !== 'eraser') {
              this.showEraser = false;
            }

            if (this.canvas_set.pen_type == 'eraser' && this.isAddShape) {
              this.isAddShape = false;
              this.showControlBar = false;
              this.shapeCanvasCtx.discardActiveObject().renderAll();
              this.canvas_context.drawImage(
                this.shapeCanvasCtx.getContext().canvas, 
                0, 0,
                this.window_width, this.window_height
              );
              this.showShapeCanvas = false;
              this.shapeCanvasCtx.clear();
            }
        },
        deep: true,
      },
      imgSrc(newVal) {
        if (newVal && newVal != ''){
          this.img_src = newVal;
          this.setCanvasBg(this.img_src);
        }
      },
      domWidHei: {
        handler(newVal) {
          if (newVal) {
            this.img_src = '';
            this.window_width = newVal.width;
            this.window_height = newVal.height;

            setTimeout(() => {
              this.init_canvas();
            }, 100);
          }
        },
        deep: true,
      },
    },
  };
</script>

<style scoped lang="scss">
#board-wrap {
  position: relative;
  user-select: none;
}

#board-wrap .recall-wrap {
  display: none;
}

#canvasPart .eraser-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
}

#canvasPart .eraser {
  -webkit-user-drag: none;
}

#shape-container {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  visibility: hidden;
}

#shape-container.show {
  z-index: 2;
  visibility: visible;
}

.control-bar {
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 330px;
  height: 60px;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 0px 4px 0px rgba(88, 109, 148, 0.5);

  top: 40%;
  left: 30%;
}

.control-bar .shape-item {
  position: relative;
  width: 53px;
  height: 100%;
  padding: 6px 0 2px 0;
  background: #9CA8C0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .text {
    margin-top: 1px;
    font-size: 14px;
    color: #FFFFFF;
  }

  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-left: 6px solid #9CA8C0;
    right: -12px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.control-bar .shape-color-list {
  display: flex;
  flex: 1;
  height: 100%;
  padding: 6px 6px 6px 10px;
  align-items: center;

  .color-item {
    position: relative;
    width: 48px;
    height: 48px;
    margin-right: 4px;
    border: 6px solid #fff;
    cursor: pointer;

    &.selected {
      border-color: #D7DEE4;
    }

    &.selected::after {
      content: '';
      position: absolute;
      top: -6px;
      right: -6px;
      bottom: -6px;
      left: -6px;
      pointer-events: none;
      border: 1px solid #586D94;
    }
  }
}

.control-bar .delete-shape {
  width: 53px;
  height: 100%;
  border-left: 1px solid #DADEE6;
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .img-icon {
    width: 30px;
    height: 30px;
  }

  .text {
    font-size: 14px;
    color: #222222;
    margin-top: 1px;
  }
}
</style>